import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import Typography from '@mui/material/Typography';
import { useCallback } from 'react';
import { useSocketSend } from '../../context/webSocket/webSocketContext';
import { addMessageBox } from '../../redux/actions/messageBoxesActions';
import { thunkSetThemeBackgroundFromUserSettingChange } from '../../redux/actions/themeActions';
import { useAppDispatch, useAppSelector } from '../../redux/store';
import { ALL_THEME_BACKGROUND_PROPERTIES } from '../../types/themeBackgroundTypes';
import { FormControlContainer } from '../formControlContainer';
import { PowerPlayerFeatureIndicator } from '../messageBoxes/settingsModal/powerPlayerFeatureIndicator';
import { ACTIVE_OPTION_COLOR, INACTIVE_OPTION_COLOR } from '../messageBoxes/settingsModal/settingsModalConstants';
import { ThemeRoomBackgroundAnimationControl } from './themeRoomBackgroundAnimationControl';
const ARIA_LABEL = 'room background setting';
const BACKGROUNDS_LIST_CSS = css `
  display: flex;
  flex-flow: row wrap;
  filter: drop-shadow(5px 5px 0 rgba(0, 0, 0, 0.1));
  padding: 3px;
`;
export const ThemeRoomBackgroundControls = ({ isSelfPanel }) => {
    const dispatch = useAppDispatch();
    const socketSend = useSocketSend();
    const currThemeBackgroundType = useAppSelector((state) => state.theme.themeBackground?.type);
    const isPowerPlayer = useAppSelector((state) => state.selfData.isPowerPlayer);
    const onClickRoomBackground = useCallback((themeBackgroundType) => {
        if (isPowerPlayer) {
            dispatch(thunkSetThemeBackgroundFromUserSettingChange('default', themeBackgroundType, socketSend));
        }
        else if (isSelfPanel) {
            dispatch(addMessageBox({ type: 'needs-power-player', powerPlayerFeatureMessageType: 'themes' }));
        }
    }, [dispatch, isPowerPlayer, socketSend, isSelfPanel]);
    const sizePx = isSelfPanel ? 80 : 100;
    const isClickable = isPowerPlayer || isSelfPanel;
    const contents = (_jsxs(_Fragment, { children: [_jsxs(Typography, { component: 'div', children: [_jsx("span", { "aria-hidden": true, children: "Room Background" }), _jsx(PowerPlayerFeatureIndicator, { powerPlayerBoltColor: isSelfPanel ? 'black' : 'yellow', isClickable: isSelfPanel && !isPowerPlayer })] }), _jsx(ThemeRoomBackgroundAnimationControl, {}), _jsx("div", { css: BACKGROUNDS_LIST_CSS, children: Object.values(ALL_THEME_BACKGROUND_PROPERTIES).map((themeBackgroundProperties, i) => {
                    const { type, label, imageUrl: fullImageUrl } = themeBackgroundProperties;
                    const imageUrl = 'thumbnailImageUrl' in themeBackgroundProperties
                        ? themeBackgroundProperties.thumbnailImageUrl
                        : fullImageUrl;
                    return (_jsx("div", { title: label, css: css `
                border: 4px solid ${currThemeBackgroundType === type ? ACTIVE_OPTION_COLOR : INACTIVE_OPTION_COLOR};
                cursor: ${isClickable ? 'pointer' : undefined};
                user-select: none;
                margin: 3px;
                width: ${sizePx}px;
                height: ${sizePx}px;
                overflow: hidden;
                &:hover {
                  border-color: ${isClickable ? 'white' : undefined};
                }
              `, onClick: () => onClickRoomBackground(type), children: _jsx("img", { draggable: false, src: imageUrl }) }, i));
                }) })] }));
    return isSelfPanel ? (_jsx("div", { "aria-label": ARIA_LABEL, children: contents })) : (_jsx(FormControlContainer, { "aria-label": ARIA_LABEL, children: contents }));
};
